module.exports = __webpack_public_path__ + "img/risorse_costi_aziendali.961da359.png";